import { Freeze } from 'react-freeze'
import { CSSProperties, forwardRef, ReactNode, RefObject } from 'react'
import { isPhoneOrTablet, SIMULATED_PHONE_WIDTH } from '$func/environmentInfo'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import {
  safeAreaCssVariables,
  stickToTopTransform,
  viewportHeight,
  viewportHeightConsideringNotch,
} from '$setup/visual-viewport'
import { useIsFullscreenEnabled } from '$logic/fullscreen/fullscreen-mode'
import { useIsRecordingCall } from '$logic/call'

export const OVERLAY_PANEL_Z_INDEX_FACTOR = 20

export const VisibilityHandler = forwardRef(function VisibilityHandlerComponent(
  {
    children,
    zIndex,
    considerIOSNotch = false,
    freezeChildren,
    style,
  }: {
    children: ReactNode
    zIndex: number
    considerIOSNotch?: boolean
    freezeChildren?: boolean
    style?: CSSProperties
  },
  ref,
) {
  const isDesktop = useIsDesktopSize()
  const isFullscreenEnabled = useIsFullscreenEnabled()
  const isRecordingCall = useIsRecordingCall()

  return (
    <div
      ref={ref as RefObject<HTMLDivElement>}
      style={{
        zIndex,
        position: isDesktop ? 'static' : 'fixed',

        ...(considerIOSNotch
          ? {
              top: safeAreaCssVariables.insetTop,
              left: safeAreaCssVariables.insetLeft,
              right: safeAreaCssVariables.insetRight,
              height: viewportHeightConsideringNotch,
            }
          : {
              top: 0,
              left: 0,
              right: 0,
              height: viewportHeight,
            }),
        transform: isFullscreenEnabled ? undefined : stickToTopTransform,
        overflow: 'hidden',
        pointerEvents: freezeChildren ? 'none' : 'auto',

        ...(!isPhoneOrTablet && !isDesktop && !isRecordingCall
          ? {
              maxWidth: SIMULATED_PHONE_WIDTH,
              margin: 'auto',
            }
          : null),

        ...style,
      }}
    >
      <Freeze freeze={typeof freezeChildren !== 'undefined' && freezeChildren}>
        {children}
      </Freeze>
    </div>
  )
})
